import {createStore} from "redux";
import RootReducers from "../Reducer";

const store=createStore(RootReducers);


export default store;